import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import portalImage from "../../src/public/UCI-Portal-Logo.png";
import { config } from "../config";
import QuestionCards from "./questionCards";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2

interface WelcomeMessageProps {
  chatId: string;
  handleNewChat?: any;
  handleSubmit?: any;
  setSelectedQ?: any;
  setCurrentMessage?: any;
}

export default function WelcomeMessage(props: WelcomeMessageProps) {
  return (
    <Box
      sx={{
        display: "flex",
        marginBottom: "1%",
        marginTop: { xs: "4vh", md: "8vh", lg: "10vh" },
        height: "100%",
        overflowY: "auto", // Make the content scrollable along the y-axis
        overflowX: "hidden", // Hide the horizontal scrollbar
      }}
    >
      <Box>
        <Grid container spacing={2}>
          <Grid xs={12} md={3} order={{ xs: 2, md: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={portalImage}
                alt="phone"
                sx={{
                  width: { xs: "60%", md: "100%" }, // Responsive width
                  height: "auto",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: { xs: "0 auto", md: "0" }, // Center the image on xs screens
                }}
              />
            </Box>
          </Grid>
          <Grid xs={12} md={9} order={{ xs: 1, md: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "100%", // Allow the height to be determined by the content
              }}
            >
              <Typography
                sx={{ fontWeight: "bold", fontSize: "22px" }}
                variant="button"
              >
                Welcome to {config.applicationName}
              </Typography>

              <Typography sx={{ fontSize: "20px" }}>
                {config.applicationSummary}
              </Typography>
            </Box>
          </Grid>
          <Grid xs={12} order={{ xs: 3 }}>
            <Typography
              variant="subtitle1"
              sx={{
                marginTop: "3%",
                fontWeight: "bold",
              }}
            >
              Some things you can ask:
            </Typography>
            <QuestionCards handleSubmit={props.handleSubmit} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
